import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// 引入 lib-flexible
import "amfe-flexible/index.js";


// 引入组件
import { Swiper, SwiperItem, Icon, Popup, InfiniteLoading, Toast, ImagePreview } from "@nutui/nutui";
import "@nutui/nutui/dist/style.css";


createApp(App)
.use(store)
.use(router)
.use(Icon)
.use(Swiper)
.use(SwiperItem)
.use(Popup)
.use(InfiniteLoading)
.use(Toast)
.use(ImagePreview)
.mount('#app')
